import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-4 mt-5">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h5>📈 Stock Training Website</h5>
            <p className="mb-0">
              Learn stock market fundamentals, investment basics, and trading principles 
              with our comprehensive educational platform.
            </p>
          </div>
          <div className="col-md-3">
            <h6>Quick Links</h6>
            <ul className="list-unstyled">
              <li><Link to="/fundamentals" className="text-light text-decoration-none">Stock Market Fundamentals</Link></li>
              <li><Link to="/investment-basics" className="text-light text-decoration-none">Investment Basics</Link></li>
              <li><Link to="/trading-principles" className="text-light text-decoration-none">Trading Principles</Link></li>
              <li><Link to="/risk-management" className="text-light text-decoration-none">Risk Management</Link></li>
            </ul>
          </div>
          <div className="col-md-3">
            <h6>Resources</h6>
            <ul className="list-unstyled">
              <li><Link to="/market-analysis" className="text-light text-decoration-none">Market Analysis</Link></li>
              <li><Link to="/glossary" className="text-light text-decoration-none">Glossary</Link></li>
              <li><Link to="/quiz" className="text-light text-decoration-none">Knowledge Quiz</Link></li>
            </ul>
          </div>
        </div>
        <hr className="my-4" />
        <div className="row">
          <div className="col-md-6">
            <p className="mb-0">&copy; 2025 Stock Training Website. All rights reserved.</p>
          </div>
          <div className="col-md-6 text-md-end">
            <p className="mb-0">Educational content for learning purposes only.</p>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <div className="disclaimer p-3 bg-secondary bg-opacity-25 rounded">
              <h6 className="text-warning">Disclaimer</h6>
              <p className="small mb-0">
                This website is for educational and informational purposes only. The content is not intended to be a substitute for professional financial advice, 
                consultation, or recommendation. All information, content, and materials available on this site are for general informational purposes only. 
                We do not provide financial advice, investment recommendations, or guidance that considers your specific needs and circumstances. 
                Before making any investment decisions, please consult with a qualified financial advisor, tax professional, or attorney. 
                Investing involves risk, including the possible loss of principal. Past performance is not indicative of future results.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
